import { useTheme } from 'styled-components';

import { IconProps } from '~types/icon';

export default function ChevronRight({ width = 8, height = 13, color, ...props }: IconProps) {
  const theme = useTheme();

  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 8 13'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <path
        d='M1.99984 0.5L0.589844 1.91L5.16984 6.5L0.589844 11.09L1.99984 12.5L7.99984 6.5L1.99984 0.5Z'
        fill={color ?? theme.colors.gray700}
      />
    </svg>
  );
}
